import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const CustomPagination = ({
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  itemName = "entries",
  className = "",
}) => {
  if (totalItems === 0) return null;

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePage = (e, page) => {
    e.preventDefault();
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      if (onPageChange) onPageChange(page);
    }
  };

  const renderPages = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (endPage - startPage < 4) {
      if (startPage === 1) {
        endPage = Math.min(5, totalPages);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, totalPages - 4);
      }
    }

    if (startPage > 1) {
      pages.push(
        <PaginationItem key={1} active={currentPage === 1}>
          <PaginationLink href="#page" onClick={(e) => handlePage(e, 1)}>
            1
          </PaginationLink>
        </PaginationItem>
      );
      if (startPage > 2) {
        pages.push(
          <PaginationItem key="ellipsis-start" disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PaginationItem key={i} active={currentPage === i}>
          <PaginationLink href="#page" onClick={(e) => handlePage(e, i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <PaginationItem key="ellipsis-end" disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        );
      }
      pages.push(
        <PaginationItem key={totalPages} active={currentPage === totalPages}>
          <PaginationLink href="#page" onClick={(e) => handlePage(e, totalPages)}>
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );
    }

    return (
      <Pagination className="pagination justify-content-end mb-0">
        <PaginationItem disabled={currentPage <= 1}>
          <PaginationLink
            href="#prev"
            onClick={(e) => handlePage(e, currentPage - 1)}
            aria-label="Previous"
          >
            <i className="fas fa-angle-left" />
          </PaginationLink>
        </PaginationItem>

        {pages}

        <PaginationItem disabled={currentPage >= totalPages}>
          <PaginationLink
            href="#next"
            onClick={(e) => handlePage(e, currentPage + 1)}
            aria-label="Next"
          >
            <i className="fas fa-angle-right" />
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-between flex-wrap w-100 ${className}`}
    >
      <div className="text-muted text-sm mb-2 mb-md-0">
        Showing <strong>{startItem}</strong> to <strong>{endItem}</strong> of{" "}
        <strong>{totalItems}</strong> {itemName}
      </div>
      <div>{renderPages()}</div>
    </div>
  );
};

export default CustomPagination;
